import { useDragLayer } from "react-dnd";

const CustomDragLayer = () => {
  const { isDragging, currentOffset } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getSourceClientOffset(),
  }));

  if (!isDragging || !currentOffset) return null;

  const layerStyles = {
    position: "fixed",
    pointerEvents: "none",
    left: 0,
    top: 0,
    transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`,
    zIndex: 1000,
  };

  return (
    <div
      style={layerStyles}
      className="bg-white text-white p-2 rounded shadow w-[56px] h-[56px] flex items-center justify-center border border-white"
    >
      <span className="text-yellow-500 text-3xl self-center mx-auto">🏆</span>
    </div>
  );
};

export default CustomDragLayer;
